// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  // Prod
  // url: "https://gmmpl.disclive.in/index.php?r=",
  // imageUrl: "https://gmmpl.disclive.in/",
  //testing
  // url: "https://logicabsoluteapi.disctesting.in/api",
  // imageUrl: "https://logicabsoluteapi.disctesting.in/",
  // Pythonurl: "https://logicabsolutechatwebhook.disctesting.in",
  // pmsUrl: "https://logicabsolute.disctesting.in/",

  //local
  // url: "http://localhost:9001/api",
  // Pythonurl: "http://127.0.0.1:7000",
  // imageUrl: "http://localhost/iMake_PMS/",
  // pmsUrl: "http://localhost/iMake/iMake_PMS/",

  //gmmpl
  url: "https://gmmpl-api.disclive.in/api",
  imageUrl: "https://gmmpl-api.disclive.in/api",
  Pythonurl: "https://gmmpl-chatwebhook.disclive.in",
  pmsUrl: "https://gmmpl.disclive.in/",

  flashtype: "success",
  flashmsg: "-",
  flashactive: "flashnone",
  bucketCount: 0,
  isLoaderActive: false,
  projectName: "",
};
